import type { ChangeEvent } from 'react'
import { forwardRef, useEffect, useState } from 'react'
import { Box, rem, TextInput as MantineTextInput } from '@mantine/core'

import type { TextInputProps } from '@/components/TextInput/TextInput.types'

import classes from './TextInput.module.css'

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ containerProps, onChange, value, ...props }, ref) => {
    const [localValue, setLocalValue] = useState(value || '')

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      onChange?.(event)

      setLocalValue(event.currentTarget.value)
    }

    useEffect(() => {
      setLocalValue(value || '')
    }, [value])

    return (
      <Box {...containerProps}>
        <MantineTextInput
          ref={ref}
          className={classes.textInput}
          onChange={handleChange}
          radius={rem(8)}
          value={localValue}
          {...props}
        />
      </Box>
    )
  },
)
